/**
 * in this module there are all the related functions for:
 *  - initialize the layer
 *  - add the layer to the map
 *  - initialize the datepicker
 */
/**
 * import modules
 */
import TileLayer from 'ol/layer/Tile'
import TileWMS from 'ol/source/TileWMS'
import TileGrid from 'ol/tilegrid/TileGrid'
import functions from '../common/functions'
import map from '../common/map'
import overlay from '../common/overlay'


/**
 * global vars
 */

let pmfeatlayer = ''
let pmproplayer = ''
let sQLayers
var pageconfig = JSON.parse($('#pageconfig').val())
/**
 * create the parkmap layer
 */

let initPmLayer = () => {
  /**
   * get the settings from the functions module
   * update the vars accordingly
   */
  /**
   * set the correct layers
   */

   sQLayers = functions.getLayerList('parkmap')
   if (sQLayers === '') {
     // no parking layers so end function
     return
   }
  /**
   * get resolutions from scale
   */

  // final resolutions array
  const resolutions = []
  // temp scale array
  const scaleArray = []
  // scales array
  const scales = pageconfig.scales.split(',')
  // create a temporary array of scales in number
  functions.getScale(scales, scaleArray)
  // create the final resolutions array
  functions.setResolution(scaleArray, resolutions)

  /**
  * get the extent of the visible map
   */
  //let layerinfo = pageconfig.layers.find(el => el.layers === "parkmap");
  //this wont work on ie11 so need to use function below

  var layerinfo = functions.altFind(pageconfig.layers, function(e) {
  return e.layers === "parkmap"
  })
  const setExt = pageconfig.bounds.split(',')
  const ext = [parseInt(setExt[0]), parseInt(setExt[1]), parseInt(setExt[2]), parseInt(setExt[3])]

  /**
   * get the current date
   * set the default date to display the restrictions
   */

  const today = new Date()
  let sDTo = `${today.getFullYear()}-${functions.leadZero(today.getMonth() + 1)}-${functions.leadZero(today.getDate())}`


  // dummy parameter to use for FRA
  let iDelRef = 0

  // feature layer
  pmfeatlayer = new TileLayer({
    className: 'featlayer',
    // this extent limit the visible map
    name: 'parkmap',
    extent: ext,
    // Load low-resolution tiles up to preload levels. By default preload is 0, which means no preloading
    preload: Infinity,
    source: new TileWMS({
      url: layerinfo.wmsfeat,
      params: {
        'LAYERS': sQLayers,
        MYORDERS: $('#featclick').val(),
        DTO: sDTo,
        format: 'image/png'
      },
      ratio: 1,
      gutter: 40,
      serverType: 'mapserver',
      crossOrigin: 'anonymous',
      projection: 'EPSG:27700',
      tileGrid: new TileGrid({
        resolutions: resolutions,
        extent: ext,
        tileSize: [128, 128]
      })
    })
  })

  /**
   * proposed orders layer
   * not added to the map until #proposedSwitch is checked
   * no DTO so the datepicker does not hide proposed items
   */

  const sPropLayers = functions.getLayerList('proplayer')
  if (sPropLayers !== '') {
    pmproplayer = new TileLayer({
      className: 'featlayer',
      name: 'proplayer',
      extent: ext,
      preload: Infinity,
      source: new TileWMS({
        url: layerinfo.wmsfeat,
        params: {
          'LAYERS': sPropLayers,
          MYORDERS: $('#featclick').val(),
          format: 'image/png'
        },
        ratio: 1,
        gutter: 40,
        serverType: 'mapserver',
        crossOrigin: 'anonymous',
        projection: 'EPSG:27700',
        tileGrid: new TileGrid({
          resolutions: resolutions,
          extent: ext,
          tileSize: [128, 128]
        })
      })
    })
  }

  /**
   * end let initPmLayer = () => {
   */
}

/**
 * update the parkmap layer parameters
 */

const updateLayerParams = (sOrderSel, iDelRef) => {
  /**
   * hide the layer
   */
  //check for accident layers otherwise return
  if (functions.getLayerList('parkmap') === '') {return}

  pmfeatlayer.setVisible(false)
  if (pmproplayer) {
    pmproplayer.setVisible(false)
  }

  /**
   * if the visible restriction array is empty stop and return
   */

  if ($('#featclick').val() === '') {
    return
  }

  /**
   * get the date from the datepicker
   * convert the date from the datepicker to a PG format
   * once is converted it can be use as a parameter
   */

  let dDTo = ''
  const today = new Date()

  if ($('#activedate').val()) {
    dDTo = $('#activedate').val().split('/').reverse().join('-')
  }
  else {
    dDTo = `${today.getFullYear()}-${functions.leadZero(today.getMonth() + 1)}-${functions.leadZero(today.getDate())}`
  }

  /**
   * initialize suspid
   * get the url parameters
   */

  let suspid
  let urlpos = window.location.search.replace('?', '')

  /**
   * check if in the URL you have the suspid parameter
   * PSA staff website
   * https://www.traffwebdev.uk/psastaff/index.html?suspid=c123456354673
   */

  if (urlpos.search('suspid') > -1 && urlpos.search('defpos') === -1) {
    let sFindID = urlpos.replace('suspid=', '')
    suspid = sFindID
  }

  /**
   * update the restrictions to dipslay
   * update the date
   * refresh the source
   * show the layer
   */

  pmfeatlayer.getSource().getParams().MYORDERS = $('#featclick').val()
  pmfeatlayer.getSource().getParams().DTO = dDTo
  pmfeatlayer.getSource().refresh()
  pmfeatlayer.setVisible(true)

  /**
   * update the proposed orders layer while it is shown
   * MYORDERS only - the date does not apply to proposed items
   */

  if (pmproplayer && $('#proposedSwitch').is(':checked')) {
    pmproplayer.getSource().getParams().MYORDERS = $('#featclick').val()
    pmproplayer.getSource().refresh()
    pmproplayer.setVisible(true)
  }

  map.getMapTab()
/**
 * end const updateLayerParams = (sOrderSel, iDelRef) => {
 */
}

/**
 * remove the whole parmak layer
 */

$('#pmlayerSwitch').on('click', function () {
  /**
   * assign this to the variable $this
   */

  let $this = $(this)

  /**
   * hide the popup
   */

  overlay.overlay.setPosition(undefined)

  /**
   * check if the value is on
   * change the value to off
   * remove the check class and apply the times class
   * remove the pmfeatlayer
   * hide the parkmap legend
   */

  if ($this.val() === 'on') {
    $this.val('off')
    $this.removeClass('fa-check').addClass('fa-times')
    map.getMap().removeLayer(pmfeatlayer)
    $('#pmlegend').hide()
  }

  /**
   * check if the value is off
   * change the value to on
   * remove the times class and apply the check class
   * add the pmfeatlayer
   * show the parkmap legend
   */
  else {
    $this.val('on')
    $this.removeClass('fa-times').addClass('fa-check')
    map.getMap().addLayer(pmfeatlayer)
    pmfeatlayer.setZIndex(20)
    $('#pmlegend').css('display', 'flex')
  }

  /**
   * end $('#pmlayerSwitch').on('click', function () {
   */
})

/**
 * add or remove the proposed orders layer
 */

$('#proposedSwitch').on('change', function () {
  if (!pmproplayer) {
    return
  }

  /**
   * hide the popup
   */

  overlay.overlay.setPosition(undefined)

  /**
   * checked - refresh MYORDERS with the current selection and add the layer under the confirmed layer
   * unchecked - remove the layer so it is not drawn or queried by the popup
   */

  if ($(this).is(':checked')) {
    pmproplayer.getSource().getParams().MYORDERS = $('#featclick').val()
    pmproplayer.getSource().refresh()
    pmproplayer.setVisible($('#featclick').val() !== '')
    map.getMap().addLayer(pmproplayer)
    pmproplayer.setZIndex(19)
  } else {
    map.getMap().removeLayer(pmproplayer)
  }

  map.getMapTab()

  /**
   * end $('#proposedSwitch').on('change', function () {
   */
})

/**
 * initialize the datepicker
 */

const initDatePicker = () => {
  //check for parking layers otherwise return
  if (functions.getLayerList('parkmap') === '') {return}
  /**
   * wrap everything inside an onload event listener (IE bug with form)
   */

  document.addEventListener('DOMContentLoaded', () => {
    /**
     * reset the parkingdateForm
     */

    if ($('#parkingdateForm').length > 0) {
      document.getElementById('parkingdateForm').reset()
    }

    /**
     * initialize the datepicker with the date of today
     */
    const today = new Date()
    const inpvalue = `${functions.leadZero(today.getDate())}/${functions.leadZero(today.getMonth() + 1)}/${today.getFullYear()}`

    $('#activedate').val(inpvalue)

    /**
     * set the datepicker options
     */

    $('#activedate').datepicker({
      format: 'dd/mm/yyyy',
      autoclose: true,
      startDate: '01/01/1950',
      endDate: '+20y',
      orientation: 'bottom auto'
    }).on('show', function (e) {
      e.stopPropagation()
    })


    if (pageconfig.appname.type === 'consult') {
      $('#parkingdate').css('display','none')
    }
    /**
     * end onload eventlistener
     */
  })

  /**
   * click event listener on the display button
   */

  $('#pmdatedisplay').click(function (e) {
    /**
     * stop propagation and prevent default
     */

    e.preventDefault()
    e.stopPropagation()

    /**
     * update the parkmap layer
     * hide the popup
     */

    updateLayerParams($('#featclick').val(), 0)
    overlay.overlay.setPosition(undefined)

    // hide the menu if is a mobile
    if (functions.mobileTabletView()) {
      $('#dropdownToolsMobile').trigger('click')
    }
  })

  /**
   * simulate a click event on the display button when the ENTER key is pressed inside the input
   */

  $('#activedate').keypress(function (e) {
    if (e.which === 13) {
      $('#pmdatedisplay').click()
    }
  })

/**
 * end const initDatePicker = () => {
 */
}

/**
 * export the layers
 */

const pmlayer = () => {
  return pmfeatlayer
}

const sQLayer = () => {
  return sQLayers
}

/**
 * export the addlayer
 */

const addlayer = () => {
  //check for parking layers otherwise return
  if (functions.getLayerList('parkmap') === '') {return}
  map.getMap().addLayer(pmfeatlayer)
  pmfeatlayer.setZIndex(20)
}

/**
 * EXPORT
 */

export default {
  initDatePicker,
  updateLayerParams,
  addlayer,
  pmlayer,
  sQLayer,
  initPmLayer
}
